// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1V9Mz","header":"MessagesList_header__2Lrei","chat":"MessagesList_chat__226R9"};